import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { CenterPositionedCol } from 'components/flex-containers';

// todo needs refinemint, doesn't wotk without bottom nav
const StyledContainer = styled(CenterPositionedCol)({
  position: 'fixed',
  bottom: 29,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '30px 0',
  width: '100%',
  '&::after': {
    content: "''",
    position: 'absolute',
    width: '100%',
    height: '100%',
    backdropFilter: 'blur(2px)',
    zIndex: -1
  }
});

export const FloatingBlurredLayout = ({
  children
}: {
  children: ReactNode;
}) => {
  return <StyledContainer>{children}</StyledContainer>;
};
